/** SDK version — updated automatically by mix update.sdks */
export const SDK_VERSION = "0.15.2";

/** Default API version sent in every request — updated automatically by mix update.sdks */
export const DEFAULT_API_VERSION = "2026-05-13";
